export default __webpack_public_path__ + "static/EvolvingEnterpriseMobImg-1a205db150477e76b1378ed22a45e90b.webp";